"use client";

import { useState } from "react";
import BookNewCall from "@/components/CTA/BookNewCall/BookNewCall";
import AcceleratorLeadModal from "@/components/Landing/AcceleratorLeadModal/AcceleratorLeadModal";

export default function AcceleratorCTA() {
  const [showLeadModal, setShowLeadModal] = useState(false);

  return (
    <>
      <BookNewCall onCtaClick={() => setShowLeadModal(true)} />
      <AcceleratorLeadModal
        open={showLeadModal}
        onOpenChange={setShowLeadModal}
        accelerator="general"
        calLink="https://cal.eu/believemy/accelerateur"
      />
    </>
  );
}
